import { render, staticRenderFns } from "./OptionalLink.vue?vue&type=template&id=6d874771&"
import script from "./OptionalLink.vue?vue&type=script&lang=js&"
export * from "./OptionalLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports